export default function Counter() {
	return <>Counte</>;
}
